<template lang="pug">
.box
  .box-body
    .alert.alert-info(v-if="tags.length > 0 && !onLoading('fetch-override-pricebook-products-count')")
      template(v-if="productsPoolCount > 0")
        | Adding {{ productsPoolCount }} products into pricebook
      template(v-else)
        | No products found in the selected tags

    .form-group.m-b-0(:class="{'has-danger': $v.tags.$error}")
      multiselect(
        :loading="onLoading('fetch-tag')"
        name="tags"
        deselect-label=""
        label="name"
        select-label=""
        track-by="id"
        v-model="tags"
        :close-on-select="false"
        :hide-selected="true"
        :multiple="true"
        :options="tagList"
        @input="onTagsChange"
        @search-change="refreshTagList"
      )

      div(v-if="$v.tags.$error")
        span.form-error-msg(v-if="!$v.tags.requiredIf") At least one tag is required.

    override-values-form(:onChange="onOverrideValuesChange")
  .box-footer.b-t.text-right
    button.btn.m-r-sm(:disabled="onLoading('add-batch-override-entries')" @click="cancel") Cancel
    button.btn.primary(:disabled="!canSubmit" @click="createEntries") Setup
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import TagMixin from '@js/mixins/tags';
import OverrideValuesForm from './override-values-form';
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';

export default {
    components: {
        OverrideValuesForm,
    },

    mixins: [TagMixin, validationMixin],

    props: {
        pricebookId: {
            type: Number,
            required: true,
        },
        onCancel: {
            type: Function,
            required: true,
        },
    },

    data() {
        return {
            tags: [],
            overrideEntry: {
                price_adjustment_mode: 'none',
                price: '0',
            },
        };
    },

    computed: {
        ...mapGetters('override_pricebook', ['productsPoolCount']),
        canSubmit: function() {
            return (
                this.tags.length > 0 &&
                !this.onLoading('fetch-pricebook-products-count') &&
                this.productsPoolCount > 0
            );
        },
    },

    created() {
        this.getTagListIfNecessary();
    },

    validations: {
        tags: {
            required,
        },
    },

    methods: {
        onTagsChange(values) {
            let params = {
                pricebookId: this.pricebookId,
                filters: {
                    tag_ids: this.tags.map(t => t.id),
                },
            };
            this.getOverridePricebookProductsCount(params);
        },
        cancel: function() {
            this.onCancel();
        },
        async createEntries() {
            try {
                await this.addBatchEntries({
                    pricebookId: this.pricebookId,
                    filters: { tag_ids: this.tags.map(t => t.id) },
                    params: this.overrideEntry,
                });
                this.showToastrSuccess();
                this.getOverridePricebook(this.pricebookId);
            } catch (e) {
                this.showApiError(e);
            }
        },
        onOverrideValuesChange: function(val) {
            this.overrideEntry = val;
        },
        ...mapActions('override_pricebook', [
            'getOverridePricebook',
            'getOverridePricebookProductsCount',
            'addBatchEntries',
        ]),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/override_pricebook/batch/tag-filter.vue